export function LogoSplashTextShort({
  size = 21,
  color = '#1A1C1E',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size * (72 / 21)}
      height={size}
      viewBox="0 0 72 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 13.1993H3.27473C3.37178 13.9479 4.07102 14.4925 5.8975 14.4925C7.3358 14.4925 8.08481 14.1916 8.08481 13.4529C8.08481 12.7143 7.3358 12.4631 4.7628 12.1124C1.66972 11.7144 0.1717 10.5778 0.1717 8.29716C0.1717 5.59119 2.32168 4.21582 5.7283 4.21582C9.13491 4.21582 11.0087 5.84487 11.1281 8.35685H7.84095C7.7439 7.60823 7.06705 7.08843 5.48443 7.08843C3.99886 7.08843 3.4539 7.55849 3.4539 8.10317C3.4539 8.87666 4.397 8.99604 6.37777 9.26216C9.69978 9.68497 11.3794 10.8688 11.3794 13.2962C11.3794 15.9177 9.14487 17.3776 5.65364 17.3776C2.13753 17.3652 0.0970476 15.7112 0 13.1993Z"
        fill={color}
      />
      <path
        d="M12.636 10.553C12.8525 6.66567 15.3185 4.21338 19.0511 4.21338C23.2192 4.21338 25.6727 7.08599 25.6727 10.9758C25.6727 14.5622 23.0276 17.2682 19.5961 17.2682C17.9886 17.2682 16.722 16.7011 15.9705 15.7113V20.8447H12.5763V12.8138C12.5639 11.8712 12.5887 11.2693 12.636 10.5555M22.2761 10.7719C22.2761 8.81702 21.007 7.40185 19.1233 7.40185C17.2396 7.40185 15.9829 8.81453 15.9829 10.7719C15.9829 12.8237 17.2022 14.117 19.1233 14.117C21.0443 14.117 22.2761 12.7765 22.2761 10.7719Z"
        fill={color}
      />
      <path d="M30.505 0H27.0859V17.0864H30.505V0Z" fill={color} />
      <path
        d="M31.9187 11.0007C31.9187 6.90692 34.5639 4.21338 38.5876 4.21338C42.2132 4.21338 44.7862 6.66567 45.0276 10.3839C45.0774 11.2768 45.1246 11.9408 45.1968 13.5599L45.366 17.0742H42.2356L42.1883 15.4675C41.4144 16.7111 39.9761 17.3503 38.08 17.3503C34.3822 17.3627 31.9187 14.8134 31.9187 10.9982M41.621 10.8415C41.621 8.78966 40.3768 7.39936 38.503 7.39936C36.6292 7.39936 35.3253 8.78717 35.3253 10.8415C35.3253 12.8959 36.5446 14.2588 38.503 14.2588C40.3768 14.2464 41.621 13.0526 41.621 10.8415Z"
        fill={color}
      />
      <path
        d="M46.2943 13.1993H49.569C49.6661 13.9479 50.3678 14.4925 52.1918 14.4925C53.6301 14.4925 54.3791 14.1916 54.3791 13.4529C54.3791 12.7143 53.6301 12.4631 51.0571 12.1124C47.964 11.7144 46.466 10.5778 46.466 8.29716C46.466 5.59119 48.616 4.21582 52.0226 4.21582C55.4292 4.21582 57.303 5.84487 57.4224 8.35685H54.1477C54.0507 7.60823 53.3738 7.08843 51.7912 7.08843C50.3056 7.08843 49.7607 7.55849 49.7607 8.10317C49.7607 8.87666 50.7038 8.99604 52.6845 9.26216C56.0065 9.68497 57.6862 10.8688 57.6862 13.2962C57.6862 15.9177 55.4516 17.3776 51.9604 17.3776C48.4319 17.3652 46.3914 15.7112 46.2943 13.1993Z"
        fill={color}
      />
      <path
        d="M59.0646 0H62.4836L62.4364 5.54128C63.2102 4.69566 64.3698 4.22559 65.9997 4.22559C69.0928 4.22559 71.2304 6.41176 71.2304 9.60023V17.0864H67.8113V10.1797C67.8113 8.29699 67.1718 7.30463 65.2632 7.30463C63.3546 7.30463 62.4836 8.46363 62.4836 10.421V17.0864H59.0646V0Z"
        fill={color}
      />
    </svg>
  );
}
